class MultiDrawer extends CustomHTMLElement {
    constructor() {
        super();
        this.activeTab = 'search';
        this.container = this.querySelector('.multidrawer__container');
        this.tabs = this.querySelectorAll('.multidrawer__tab');
        this.contents = this.querySelectorAll('.tab-content');
        this.closeButton = this.querySelector('.multidrawer__close');
        this.overlay = this.querySelector('.overlay');
        this.mobile = window.matchMedia('(max-width: 1000px)');
        this.trigger = document.querySelectorAll('[data-drawer-trigger]')

    }

    connectedCallback() {
        this.addEventListeners();
        this.updateActiveTab();
        this.rootDelegate.on("variant:added", this.addToCart.bind(this));
        this.rootDelegate.on("cart:refresh", this.cartUpdated.bind(this));
        this.rootDelegate.on("multidrawer:open", (e) => this.open(e.detail.tab));
        this.rootDelegate.on("multidrawer:close", (e) => this.close());

    }

    cartUpdated() {
        setTimeout(() => {
            this.tabs = document.querySelectorAll('.multidrawer__tab');
            this.addEventListeners(); // Reapply event listeners to the new tabs
        }, 600);
    }



    addToCart(event) {
        this.open('minicart');
    }

    addEventListeners() {

        this.closeButton.addEventListener('click', () => this.close());

        this.tabs.forEach(tab => {
            tab.addEventListener('click', (e) => this.switchTab(e.target.dataset.tab));
        });

        this.overlay.addEventListener('click', () => this.close());

        document.addEventListener('click', (e) => {
            // Check if the click happened inside the cart drawer
            if (e.target.matches('.minicart-tab__toggle')) {
                this.switchMinicartTab(e.target.dataset.tab)
                return;
            }
            if (e.target.matches('[data-drawer-trigger]')) {
                e.preventDefault();
                this.open(e.target.dataset.drawerTrigger);
            }
        });
    }

    switchTab(tabName) {
        if (this.mobile.matches && tabName === 'minicart') {
            window.location.href = '/cart';
            return;
        }

        this.activeTab = tabName;
        this.updateActiveTab();
    }

    switchMinicartTab(tabName) {
        const tabs = this.querySelectorAll('.minicart-tab__toggle');
        const contents = this.querySelectorAll('[data-minicart-toggle]');

        // Remove active class from all tabs
        tabs.forEach(t => t.classList.remove('active'));

        // Add active class to the clicked tab
        const activeTab = Array.from(tabs).find(t => t.dataset.tab === tabName);
        if (activeTab) activeTab.classList.add('active');

        // Toggle content visibility
        contents.forEach(content => {
            content.classList.toggle('active', content.getAttribute('data-minicart-toggle') === tabName);
        });
    }

    updateActiveTab() {
        this.tabs.forEach(tab => {
            tab.classList.toggle('active', tab.dataset.tab === this.activeTab);
        });
        this.contents.forEach(content => {
            content.classList.toggle('active', content.classList.contains(this.activeTab));
        });

        setTimeout(() => this.focusFirstInput(), 600);
    }

    focusFirstInput() {
        const activeContent = Array.from(this.contents).find(content => content.classList.contains(this.activeTab));
        if (activeContent) {
            const firstInput = activeContent.querySelector('input[type="text"], input[type="email"]');
            if (firstInput) {
                firstInput.focus();
            }
        }
    }

    open(tabName = 'search') {
        this.activeTab = tabName;
        this.classList.add('open');
        document.body.classList.add('drawer-open');
        this.updateActiveTab();
    }

    close() {
        this.classList.remove('open');
        document.body.classList.remove('drawer-open');
    }
}

customElements.define('multi-drawer', MultiDrawer);
